import type { FC, ReactNode } from 'react'

import styled from 'styled-components'

interface TitleProps {
  actions?: ReactNode
  className?: string
  subtitle?: ReactNode
  titleText?: string
}

const _SearchResultsTitle: FC<TitleProps> = ({ actions, className, subtitle, titleText }) => {
  return (
    <div className={className}>
      <header>
        <h1 data-test-id="search-results-title">{titleText}</h1>
        {subtitle}
      </header>
      {actions && <aside>{actions}</aside>}
    </div>
  )
}

_SearchResultsTitle.displayName = 'Title'

/**
 * A Title text component with optional children
 */
export const SearchResultsTitle = styled(_SearchResultsTitle)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  margin: `${theme.spacings.medium} 0`,
  justifyContent: 'baseline',

  header: {
    alignItems: 'baseline',
    flex: '1 1 320px',
    display: 'flex',
    flexWrap: 'wrap',
    margin: `0 ${theme.spacings.small}`,
    paddingRight: theme.spacings.small,

    h1: {
      ...theme.variants.title1,
      textTransform: 'none',

      '&:not(:last-child)': {
        marginRight: theme.spacings.xxSmall,
      },
    },
  },

  aside: {
    margin: `${theme.spacings.xxSmall} ${theme.spacings.xxSmall} 0`,
    display: 'flex',

    '> *:not(:first-child)': {
      marginLeft: theme.spacings.xxSmall,
    },
  },

  [`@media (min-width: calc(${theme.breakpoints.tablet} + 1px))`]: {
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,

    header: {
      margin: 0,
    },
  },
}))
